import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../hooks';

// TODO: move out into individual view service folders (probably)
export type AddPlayerViewState = {
  playerIdToConneqt?: string;
  emailToConneqtWith?: string;
};

export type AddNewPlayerViewState = {
  pendingConneqtId?: string;
  playerClues?: string;
};

export type AddConneqtViewState = {
  selectedPlayerId?: string;
  responseEmail?: string;
};

type ValidViewState =
  | AddNewPlayerViewState
  | AddPlayerViewState
  | AddConneqtViewState;

export enum ViewStates {
  addConneqt = 'addConneqt',
  addPlayer = 'addPlayer',
  conneqtNewPlayer = 'conneqtNewPlayer',
}

export interface ViewState {
  [ViewStates.addConneqt]: AddConneqtViewState;
  [ViewStates.addPlayer]: AddPlayerViewState;
  [ViewStates.conneqtNewPlayer]: AddNewPlayerViewState;
}

const initialState: ViewState = {
  [ViewStates.addConneqt]: {},
  [ViewStates.addPlayer]: {},
  [ViewStates.conneqtNewPlayer]: {},
};

/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
export const viewSlice = createSlice({
  name: 'viewState',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    dispatchViewStates(
      state,
      action: PayloadAction<{
        viewState: Partial<ValidViewState>;
        viewName: ViewStates;
      }>,
    ) {
      // TODO: what if we want to clear all before adding payload?
      state[action.payload.viewName] = {
        ...state[action.payload.viewName],
        ...action.payload.viewState,
      };
    },
    dispatchClearView(state, action: PayloadAction<ViewStates>) {
      // TODO: set defaults if there are any from above
      state[action.payload] = {};
    },
  },
});

export const { dispatchViewStates, dispatchClearView } = viewSlice.actions;

export const viewStateSelectors = (state: RootState) => {
  return state.viewState;
};
